import { PD, B } from "../theme";
import { canHover } from "./hover";

export function BackArrow({ onClick, color = PD.dim, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        background: "none", border: "none", cursor: disabled ? "default" : "pointer",
        padding: "14px 14px 14px 0",
        display: "flex", alignItems: "center", gap: 6,
        ...B, fontSize: 13, color, opacity: disabled ? 0.4 : 0.8, minHeight: 44, transition: "opacity 0.2s",
      }}
      onMouseEnter={(e) => { if (!disabled && canHover()) e.currentTarget.style.opacity = "1"; }}
      onMouseLeave={(e) => { if (!disabled) e.currentTarget.style.opacity = "0.8"; }}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 3L5 8L10 13" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      Back
    </button>
  );
}
